export default function Company() {
  return (
    <section className="py-16 sm:py-24 bg-[#fafaf8]">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1a2332] mb-4">
            事務所紹介
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12 items-center">
          <div className="rounded-3xl overflow-hidden shadow-xl h-[350px] sm:h-[450px] lg:h-[500px]">
            <img 
              src="https://public.readdy.ai/ai/img_res/3121400f37488c2fedf1fbc420295fe3.jpg"
              alt="事務所"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div className="space-y-6 sm:space-y-8">
            <div>
              <h3 className="text-xl sm:text-2xl font-bold text-[#1a2332] mb-3 sm:mb-4 flex items-center gap-2 sm:gap-3">
                <i className="ri-building-line text-[#ff6b35] text-xl sm:text-2xl"></i>
                事務所名
              </h3>
              <p className="text-base sm:text-lg text-gray-700 leading-relaxed font-bold">
                行政書士ARISEリーガルオフィス
              </p>
            </div>

            <div>
              <h3 className="text-xl sm:text-2xl font-bold text-[#1a2332] mb-3 sm:mb-4 flex items-center gap-2 sm:gap-3">
                <i className="ri-award-line text-[#ff6b35] text-xl sm:text-2xl"></i>
                専門分野
              </h3>
              <ul className="space-y-2">
                <li className="flex items-start gap-2 sm:gap-3 text-sm sm:text-base text-gray-700">
                  <i className="ri-check-line text-[#ff6b35] text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                  <span>建設業許可申請・更新</span>
                </li>
                <li className="flex items-start gap-2 sm:gap-3 text-sm sm:text-base text-gray-700">
                  <i className="ri-check-line text-[#ff6b35] text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                  <span>施工体制台帳作成</span>
                </li>
                <li className="flex items-start gap-2 sm:gap-3 text-sm sm:text-base text-gray-700">
                  <i className="ri-check-line text-[#ff6b35] text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                  <span>労務安全書類作成</span>
                </li>
                <li className="flex items-start gap-2 sm:gap-3 text-sm sm:text-base text-gray-700">
                  <i className="ri-check-line text-[#ff6b35] text-lg sm:text-xl flex-shrink-0 mt-1"></i>
                  <span>グリーンサイト等電子システム対応</span>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl sm:text-2xl font-bold text-[#1a2332] mb-3 sm:mb-4 flex items-center gap-2 sm:gap-3">
                <i className="ri-bar-chart-line text-[#ff6b35] text-xl sm:text-2xl"></i>
                実績
              </h3>
              <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
                グリーンサイト案件多数の実績がございます
              </p>
            </div>

            <div>
              <h3 className="text-xl sm:text-2xl font-bold text-[#1a2332] mb-3 sm:mb-4 flex items-center gap-2 sm:gap-3">
                <i className="ri-map-pin-line text-[#ff6b35] text-xl sm:text-2xl"></i>
                所在地
              </h3>
              <div className="space-y-2">
                <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
                  〒550-0015<br />
                  大阪市西区南堀江2-4-8-403
                </p>
                <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
                  <span className="font-bold">TEL:</span> 090-6672-0369<br />
                  <span className="font-bold">FAX:</span> 06-4560-5163
                </p>
                <p className="text-xs sm:text-sm text-[#ff6b35] font-bold mt-3">
                  ※全国対応・オンライン対応可能
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
